import axios from 'axios';
export const MODULE_GROUP_REQUEST = 'MODULE_GROUP_REQUEST';
export const MODULE_GROUP_SUCCESS = 'MODULE_GROUP_SUCCESS';
export const MODULE_GROUP_INIT = 'MODULE_GROUP_INIT';
export const MODULE_GROUP_FAIL = 'MODULE_GROUP_FAIL';

export const moduleGroupsRequest = () => {
  return {
    type: MODULE_GROUP_REQUEST
  }
}

export const moduleGroupsSuccess = (data) => {
  return {
    type: MODULE_GROUP_SUCCESS,
    moduleGroups: data
  }
}

export const moduleGroupsInit = () => {
  return {
    type: MODULE_GROUP_INIT
  }
}

export const moduleGroupsFail = () => {
  return {
    type: MODULE_GROUP_FAIL
  }
}

export const moduleGroupsManager = (authIdx = 1) => {
  return (dispatch) => {
    dispatch(moduleGroupsRequest());
    return axios.get('/api/group/getDataByAuth', { params: { authIdx: authIdx }})
      .then(response => {
        dispatch(moduleGroupsSuccess(response.data));
      })
      .catch(function (error) {
        dispatch(moduleGroupsFail());
        console.log(error);
      });
  }
}


export const moduleGroups = (state = {status: 'WAITING'}, action) => {
  switch (action.type) {
    case 'MODULE_GROUP_REQUEST':
      return {
        ...state,
        groups: [],
        status: 'WAITING'
      }
    case 'MODULE_GROUP_SUCCESS':
      return {
        ...state,
        groups: [...action.moduleGroups],
        status: 'SUCCESS',
      }
    case 'MODULE_GROUP_FAIL':
      return {
        status: 'FAIL'
      }
    case 'MODULE_GROUP_INIT':
      return {
        groups: [],
        status: 'WAITING'
      }
    default:
      return state
  }
}